import React from "react";
import { COOKIE_CONSENT_DEFAULT_CONFIG } from "../../../constants/cookieConsentDefaults";

const PreviewUi = ({ fieldsData }) => {
  const cookieStatus = localStorage.getItem("cookiesPrivacy");

  const contentBlocked = cookieStatus === "essential_only" || cookieStatus === "rejected";

  return (
    <div className="mt-3 ms-4">
      <div className="preview-custo">
        <h6>
          <b>Preview</b>
        </h6>

        {(() => {
          const trimOrFallback = (value, fallback) => {
            if (typeof value === "string") {
              const trimmed = value.trim();
              return trimmed.length ? trimmed : fallback;
            }
            return value ?? fallback;
          };

          const config = {
            modal: {
              ...COOKIE_CONSENT_DEFAULT_CONFIG.modal_details,
              ...(fieldsData?.modal_details || {}),
            },
            value: {
              ...COOKIE_CONSENT_DEFAULT_CONFIG.value,
              ...(fieldsData?.value || {}),
            },
            text:
              trimOrFallback(
                fieldsData?.pp_text,
                COOKIE_CONSENT_DEFAULT_CONFIG.pp_text
              ),
            link: {
              ...COOKIE_CONSENT_DEFAULT_CONFIG.link_details,
              ...(fieldsData?.link_details || {}),
            },
          };
          config.modal.border_weight =
            Number(config.modal.border_weight) ||
            COOKIE_CONSENT_DEFAULT_CONFIG.modal_details.border_weight;
          config.modal.bg_color = trimOrFallback(
            config.modal.bg_color,
            COOKIE_CONSENT_DEFAULT_CONFIG.modal_details.bg_color
          );
          config.modal.border_color = trimOrFallback(
            config.modal.border_color,
            COOKIE_CONSENT_DEFAULT_CONFIG.modal_details.border_color
          );

          config.value = Object.entries(config.value).reduce(
            (acc, [key, val]) => {
              acc[key] = trimOrFallback(
                val,
                COOKIE_CONSENT_DEFAULT_CONFIG.value[key]
              );
              return acc;
            },
            {}
          );

          config.link.link_text = trimOrFallback(
            config.link.link_text,
            COOKIE_CONSENT_DEFAULT_CONFIG.link_details.link_text
          );
          config.link.link_url = trimOrFallback(
            config.link.link_url,
            COOKIE_CONSENT_DEFAULT_CONFIG.link_details.link_url
          );

          const borderWeight = config.modal.border_weight;

          return (
            <div
              className="pre-cus-p"
              style={{
                border: `${borderWeight}px solid ${config.modal.border_color}`,
                background: `${config.modal.bg_color}`,
                padding: "1rem",
                borderRadius: "12px",
              }}
            >
          {contentBlocked ? (
            <div className="blocked-content-message">
              The content shared with you is standing outside, shivering in the cold,
              waiting for cookies to open the door. Enable cookies in this browser to
              gain access to the content you requested!
            </div>
          ) : (
            <>
              <p className="px-2">
                {config.text}
                <a
                  href={config.link.link_url}
                  className="privacy-link"
                >
                  {" "}
                  {config.link.link_text}{" "}
                </a>
              </p>

              <div className="button-group">
                <button
                  className="btn"
                  style={{
                    border: `1px solid ${config.value.btn1_border_color}`,
                    background: `${config.value.btn1_bg_color}`,
                    color: `${config.value.btn1_text_color}`,
                  }}
                >
                  Accept essential cookies
                </button>
                <button
                  className="btn"
                  style={{
                    border: `1px solid ${config.value.btn2_border_color}`,
                    background: `${config.value.btn2_bg_color}`,
                    color: `${config.value.btn2_text_color}`,
                  }}
                >
                  Accept all cookies
                </button>
              </div>
            </>
          )}
            </div>
          );
        })()}
      </div>
    </div>
  );
};

export default PreviewUi;
